import { render, staticRenderFns } from "./InstrumentSearchResultsTable.vue?vue&type=template&id=2ed822e4"
import script from "./InstrumentSearchResultsTable.vue?vue&type=script&lang=ts"
export * from "./InstrumentSearchResultsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports